

export default function NuestrosCursos() {
    return (

        <div className="col-12 col-sm-12 mx-auto m-4">




        <div className="card col-12 mb-2" >
                <div className='row'>
                    <div className='col-12 col-sm-4'>
                        <img className="card-img-top" src={require("./../img/servicios/avanzado.jpg")} alt="Card image cap" />
                    </div>
                    <div className='col-12 col-sm-8 p-4 '>
                        <h5  style={{ textAlign: 'justify' }} >TRABAJADOR AVANZADO</h5>
                        <p style={{ textAlign: 'justify' }} className="card-text">
                        Todo trabajador que labore en actividades de alto riesgo y que realice trabajo en alturas con desplazamiento horizontal y vertical, debe estar certificado en el NIVEL AVANZADO.<br/>
                        <strong>INTENSIDAD HORARIA DEL CURSO:</strong> 40 HORAS<br/>
                        <strong>DOCUMENTOS QUE SE DEBE PRESENTAR:</strong> CEDULA - EXAMEN MEDICO - PLANILLA PARA FISCALES
                        </p>
                    </div>
                </div>
            </div>




        <div className="card col-12 mb-2" >
            <div className='row'>
                <div className='col-12 col-sm-4'>
                    <img className="card-img-top" src={require("./../img/servicios/administrativo.jpg")} alt="Card image cap" />
                </div>
                <div className='col-12 col-sm-8 p-4 '>
                    <h5  style={{ textAlign: 'justify' }} >BASICO ADMINISTRATIVO</h5>
                    <p style={{ textAlign: 'justify' }} className="card-text">
                    Los trabajos verticales son técnicas para trabajar en altura que se basan en la utilización de anclajes, conectores, cuerdas y aparatos de progresión, descenso y posicionamiento.<br/>
                    <strong>INTENSIDAD HORARIA DEL CURSO:</strong> 8 HORAS<br/>
                    <strong>DOCUMENTOS QUE SE DEBE PRESENTAR:</strong> CEDULA - EXAMEN MEDICO - PLANILLA PARA FISCALES
                    </p>
                </div>
            </div>
        </div>

        <div className="card col-12 mb-2" >
                <div className='row'>
                    <div className='col-12 col-sm-4'>
                        <img className="card-img-top" src={require("./../img/servicios/operativo.jpg")} alt="Card image cap" />
                    </div>
                    <div className='col-12 col-sm-8 p-4 '>
                        <h5  style={{ textAlign: 'justify' }} >BASICO OPERATIVO</h5>
                        <p style={{ textAlign: 'justify' }} className="card-text">
                        Plataformas de acceso a los sitios de alturas, protegidas por barandas, debe estar certificado<br/>
                        <strong>INTENSIDAD HORARIA DEL CURSO:</strong> 10 HORAS<br/>
                        <strong>DOCUMENTOS QUE SE DEBE PRESENTAR:</strong> CEDULA - EXAMEN MEDICO - PLANILLA PARA FISCALES
                        </p>
                    </div>
                </div>
            </div>



            <div className="card col-12 mb-2" >
                <div className='row'>
                    <div className='col-12 col-sm-4'>
                        <img className="card-img-top" src={require("./../img/servicios/reentrenamiento.jpg")} alt="Card image cap" />
                    </div>
                    <div className='col-12 col-sm-8 p-4 '>
                        <h5  style={{ textAlign: 'justify' }} >REENTRENAMIENTO</h5>
                        <p style={{ textAlign: 'justify' }} className="card-text">
                        Proceso obligatorio anual en donde se actualizan conocimientos y se entrenan habilidades y destrezas en prevención y protección contra caídas<br/>
                        <strong>INTENSIDAD HORARIA DEL CURSO:</strong> 10 HORAS<br/>
                        <strong>DOCUMENTOS QUE SE DEBE PRESENTAR:</strong> CEDULA - EXAMEN MEDICO - CURSO RENOVADO - PLANILLA PARA FISCALES
                        </p>
                    </div>
                </div>
            </div>



            <div className="card col-12 mb-2" >
                <div className='row'>
                    <div className='col-12 col-sm-4'>
                        <img className="card-img-top" src={require("./../img/servicios/coordinador.jpg")} alt="Card image cap" />
                    </div>
                    <div className='col-12 col-sm-8 p-4 '>
                        <h5  style={{ textAlign: 'justify' }} >COORDINADOR</h5>
                        <p style={{ textAlign: 'justify' }} className="card-text">
                        Capacitación en el nivel coordinador de trabajo en alturas y experiencia certificada mínima de un año relacionado con trabajo en alturas<br/>
                        <strong>INTENSIDAD HORARIA DEL CURSO:</strong> 80 HORAS<br/>
                        <strong>DOCUMENTOS QUE SE DEBE PRESENTAR:</strong> CEDULA - EXAMEN MEDICO CON APTITUD PARA ALTURAS - CERTIFICADO LABORAL - PLANILLA PARA FISCALES
                        </p>
                    </div>
                </div>
            </div>





        </div>

        

    )
}


